var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 40,
    viewBox: "0 0 136 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 134,
    height: 39,
    rx: 4.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.637 21.7509C66.285 21.7509 64.368 23.5399 64.368 26.0039C64.368 28.4529 66.285 30.2569 68.637 30.2569C70.99 30.2569 72.907 28.4529 72.907 26.0039C72.906 23.5399 70.989 21.7509 68.637 21.7509ZM68.637 28.5829C67.348 28.5829 66.237 27.5199 66.237 26.0049C66.237 24.4739 67.349 23.4269 68.637 23.4269C69.926 23.4269 71.037 24.4739 71.037 26.0049C71.037 27.5189 69.926 28.5829 68.637 28.5829ZM59.323 21.7509C56.971 21.7509 55.054 23.5399 55.054 26.0039C55.054 28.4529 56.971 30.2569 59.323 30.2569C61.676 30.2569 63.593 28.4529 63.593 26.0039C63.593 23.5399 61.676 21.7509 59.323 21.7509ZM59.323 28.5829C58.034 28.5829 56.923 27.5199 56.923 26.0049C56.923 24.4739 58.035 23.4269 59.323 23.4269C60.612 23.4269 61.723 24.4739 61.723 26.0049C61.724 27.5189 60.612 28.5829 59.323 28.5829ZM48.245 23.0569V24.8609H52.563C52.434 25.8759 52.096 26.6169 51.58 27.1319C50.952 27.7599 49.969 28.4529 48.245 28.4529C45.587 28.4529 43.509 26.3099 43.509 23.6519C43.509 20.9939 45.587 18.8509 48.245 18.8509C49.679 18.8509 50.726 19.4149 51.499 20.1399L52.772 18.8669C51.692 17.8359 50.259 17.0469 48.245 17.0469C44.604 17.0469 41.543 20.0109 41.543 23.6519C41.543 27.2929 44.604 30.2569 48.245 30.2569C50.21 30.2569 51.693 29.6119 52.852 28.4039C54.044 27.2119 54.415 25.5359 54.415 24.1829C54.415 23.7649 54.383 23.3779 54.318 23.0559H48.245V23.0569ZM93.553 24.4579C93.199 23.5079 92.119 21.7509 89.912 21.7509C87.721 21.7509 85.9 23.4749 85.9 26.0039C85.9 28.3879 87.705 30.2569 90.121 30.2569C92.07 30.2569 93.198 29.0649 93.666 28.3719L92.216 27.4049C91.733 28.1139 91.072 28.5809 90.121 28.5809C89.171 28.5809 88.494 28.1459 88.059 27.2919L93.746 24.9399L93.553 24.4579ZM87.753 25.8759C87.705 24.2319 89.026 23.3949 89.977 23.3949C90.718 23.3949 91.346 23.7659 91.556 24.2969L87.753 25.8759ZM83.13 29.9999H84.998V17.4989H83.13V29.9999ZM80.068 22.7019H80.004C79.585 22.2019 78.779 21.7509 77.765 21.7509C75.638 21.7509 73.689 23.6199 73.689 26.0209C73.689 28.4049 75.638 30.2579 77.765 30.2579C78.78 30.2579 79.585 29.8069 80.004 29.2919H80.068V29.9039C80.068 31.5309 79.198 32.4009 77.797 32.4009C76.653 32.4009 75.944 31.5799 75.654 30.8869L74.027 31.5639C74.494 32.6909 75.734 34.0769 77.797 34.0769C79.988 34.0769 81.841 32.7879 81.841 29.6459V22.0099H80.069V22.7019H80.068ZM77.926 28.5829C76.637 28.5829 75.558 27.5029 75.558 26.0209C75.558 24.5219 76.637 23.4269 77.926 23.4269C79.198 23.4269 80.197 24.5219 80.197 26.0209C80.197 27.5029 79.198 28.5829 77.926 28.5829ZM102.307 17.4989H97.836V29.9999H99.701V25.2639H102.306C104.374 25.2639 106.408 23.7669 106.408 21.3819C106.408 18.9969 104.375 17.4989 102.307 17.4989ZM102.355 23.5239H99.701V19.2389H102.355C103.75 19.2389 104.542 20.3939 104.542 21.3819C104.542 22.3499 103.75 23.5239 102.355 23.5239ZM113.887 21.7289C112.536 21.7289 111.137 22.3239 110.558 23.6429L112.214 24.3339C112.568 23.6429 113.228 23.4169 113.919 23.4169C114.884 23.4169 115.865 23.9959 115.881 25.0249V25.1539C115.543 24.9609 114.819 24.6719 113.935 24.6719C112.15 24.6719 110.332 25.6529 110.332 27.4859C110.332 29.1589 111.796 30.2359 113.436 30.2359C114.69 30.2359 115.382 29.6729 115.816 29.0129H115.88V29.9779H117.682V25.1849C117.683 22.9669 116.025 21.7289 113.887 21.7289ZM113.661 28.5799C113.051 28.5799 112.198 28.2739 112.198 27.5179C112.198 26.5529 113.26 26.1829 114.177 26.1829C114.996 26.1829 115.383 26.3599 115.881 26.6009C115.736 27.7599 114.739 28.5799 113.661 28.5799ZM124.244 22.0019L122.105 27.4219H122.041L119.821 22.0019H117.811L121.14 29.5769L119.242 33.7909H121.188L126.319 22.0019H124.244ZM107.438 29.9999H109.303V17.4989H107.438V29.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9176 10.2412C47.9176 11.0792 47.6696 11.7462 47.1726 12.2442C46.6086 12.8362 45.8726 13.1322 44.9686 13.1322C44.1026 13.1322 43.3656 12.8322 42.7606 12.2322C42.1546 11.6312 41.8516 10.8872 41.8516 9.99923C41.8516 9.11023 42.1546 8.36623 42.7606 7.76623C43.3656 7.16523 44.1026 6.86524 44.9686 6.86524C45.3986 6.86524 45.8096 6.94923 46.1996 7.11623C46.5906 7.28423 46.9036 7.50723 47.1376 7.78623L46.6106 8.31423C46.2136 7.83923 45.6666 7.60223 44.9676 7.60223C44.3356 7.60223 43.7896 7.82424 43.3286 8.26824C42.8676 8.71224 42.6376 9.28923 42.6376 9.99823C42.6376 10.7072 42.8676 11.2842 43.3286 11.7282C43.7896 12.1722 44.3356 12.3942 44.9676 12.3942C45.6376 12.3942 46.1966 12.1712 46.6436 11.7242C46.9336 11.4332 47.1016 11.0282 47.1466 10.5092H44.9676V9.78824H47.8746C47.9046 9.94524 47.9176 10.0962 47.9176 10.2412Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5277 7.73529H49.7957V9.63729H52.2597V10.3583H49.7957V12.2603H52.5277V12.9983H49.0247V6.99829H52.5277V7.73529Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7785 12.9983H55.0075V7.73529H53.3315V6.99829H57.4545V7.73529H55.7785V12.9983Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4375 12.9983V6.99829H61.2085V12.9983H60.4375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6277 12.9983H63.8567V7.73529H62.1807V6.99829H66.3037V7.73529H64.6277V12.9983Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1084 12.2233C73.5184 12.8293 72.7854 13.1323 71.9084 13.1323C71.0314 13.1323 70.2984 12.8293 69.7094 12.2233C69.1194 11.6173 68.8254 10.8753 68.8254 9.99828C68.8254 9.12128 69.1194 8.37928 69.7094 7.77328C70.2984 7.16728 71.0314 6.86328 71.9084 6.86328C72.7804 6.86328 73.5124 7.16828 74.1044 7.77728C74.6964 8.38628 74.9924 9.12628 74.9924 9.99828C74.9924 10.8753 74.6974 11.6173 74.1084 12.2233ZM70.2784 11.7203C70.7224 12.1703 71.2654 12.3943 71.9084 12.3943C72.5514 12.3943 73.0954 12.1693 73.5384 11.7203C73.9824 11.2703 74.2054 10.6963 74.2054 9.99828C74.2054 9.30028 73.9824 8.72628 73.5384 8.27628C73.0954 7.82628 72.5514 7.60228 71.9084 7.60228C71.2654 7.60228 70.7224 7.82728 70.2784 8.27628C69.8354 8.72628 69.6124 9.30028 69.6124 9.99828C69.6124 10.6963 69.8354 11.2703 70.2784 11.7203Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0745 12.9983V6.99829H77.0125L79.9285 11.6653H79.9615L79.9285 10.5093V6.99829H80.6995V12.9983H79.8945L76.8435 8.10429H76.8105L76.8435 9.26029V12.9983H76.0745Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9176 10.2412C47.9176 11.0792 47.6696 11.7462 47.1726 12.2442C46.6086 12.8362 45.8726 13.1322 44.9686 13.1322C44.1026 13.1322 43.3656 12.8322 42.7606 12.2322C42.1546 11.6312 41.8516 10.8872 41.8516 9.99923C41.8516 9.11023 42.1546 8.36623 42.7606 7.76623C43.3656 7.16523 44.1026 6.86524 44.9686 6.86524C45.3986 6.86524 45.8096 6.94923 46.1996 7.11623C46.5906 7.28423 46.9036 7.50723 47.1376 7.78623L46.6106 8.31423C46.2136 7.83923 45.6666 7.60223 44.9676 7.60223C44.3356 7.60223 43.7896 7.82424 43.3286 8.26824C42.8676 8.71224 42.6376 9.28923 42.6376 9.99823C42.6376 10.7072 42.8676 11.2842 43.3286 11.7282C43.7896 12.1722 44.3356 12.3942 44.9676 12.3942C45.6376 12.3942 46.1966 12.1712 46.6436 11.7242C46.9336 11.4332 47.1016 11.0282 47.1466 10.5092H44.9676V9.78824H47.8746C47.9046 9.94524 47.9176 10.0962 47.9176 10.2412Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5277 7.73529H49.7957V9.63729H52.2597V10.3583H49.7957V12.2603H52.5277V12.9983H49.0247V6.99829H52.5277V7.73529Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7785 12.9983H55.0075V7.73529H53.3315V6.99829H57.4545V7.73529H55.7785V12.9983Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4375 12.9983V6.99829H61.2085V12.9983H60.4375Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6277 12.9983H63.8567V7.73529H62.1807V6.99829H66.3037V7.73529H64.6277V12.9983Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1084 12.2233C73.5184 12.8293 72.7854 13.1323 71.9084 13.1323C71.0314 13.1323 70.2984 12.8293 69.7094 12.2233C69.1194 11.6173 68.8254 10.8753 68.8254 9.99828C68.8254 9.12128 69.1194 8.37928 69.7094 7.77328C70.2984 7.16728 71.0314 6.86328 71.9084 6.86328C72.7804 6.86328 73.5124 7.16828 74.1044 7.77728C74.6964 8.38628 74.9924 9.12628 74.9924 9.99828C74.9924 10.8753 74.6974 11.6173 74.1084 12.2233ZM70.2784 11.7203C70.7224 12.1703 71.2654 12.3943 71.9084 12.3943C72.5514 12.3943 73.0954 12.1693 73.5384 11.7203C73.9824 11.2703 74.2054 10.6963 74.2054 9.99828C74.2054 9.30028 73.9824 8.72628 73.5384 8.27628C73.0954 7.82628 72.5514 7.60228 71.9084 7.60228C71.2654 7.60228 70.7224 7.82728 70.2784 8.27628C69.8354 8.72628 69.6124 9.30028 69.6124 9.99828C69.6124 10.6963 69.8354 11.2703 70.2784 11.7203Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0745 12.9983V6.99829H77.0125L79.9285 11.6653H79.9615L79.9285 10.5093V6.99829H80.6995V12.9983H79.8945L76.8435 8.10429H76.8105L76.8435 9.26029V12.9983H76.0745Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1123_55915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9357 7.53784C10.6447 7.84584 10.4727 8.32384 10.4727 8.94284V31.0588C10.4727 31.6788 10.6447 32.1558 10.9357 32.4638L11.0097 32.5358L23.3987 20.1468V20.0008V19.8548L11.0097 7.46484L10.9357 7.53784Z",
    fill: "url(#paint0_linear_1123_55915)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5274 24.2796L23.3984 20.1486V20.0026V19.8566L27.5284 15.7266L27.6214 15.7796L32.5144 18.5596C33.9114 19.3536 33.9114 20.6526 32.5144 21.4476L27.6214 24.2276L27.5274 24.2796Z",
    fill: "url(#paint1_linear_1123_55915)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1123_55915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6215 24.224L23.3975 20L10.9355 32.463C11.3955 32.951 12.1565 33.011 13.0135 32.525L27.6215 24.224Z",
    fill: "url(#paint2_linear_1123_55915)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.6215 15.7767L13.0135 7.4767C12.1565 6.9897 11.3955 7.0507 10.9355 7.5387L23.3985 20.0017L27.6215 15.7767Z",
    fill: "url(#paint3_linear_1123_55915)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 134,
    height: 39,
    rx: 4.5,
    stroke: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1123_55915",
    x: 10.4727,
    y: 7.14062,
    width: 23.0898,
    height: 25.7188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1123_55915"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1123_55915",
    result: "effect2_innerShadow_1123_55915"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1123_55915",
    x: 10.9355,
    y: 20,
    width: 16.6855,
    height: 12.8594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1123_55915"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1123_55915",
    x1: 22.3005,
    y1: 8.70884,
    x2: 5.51846,
    y2: 25.4908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1123_55915",
    x1: 34.3329,
    y1: 20.0026,
    x2: 10.137,
    y2: 20.0026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1123_55915",
    x1: 25.3276,
    y1: 22.2939,
    x2: 2.56915,
    y2: 45.0524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1123_55915",
    x1: 7.79695,
    y1: 0.176501,
    x2: 17.9592,
    y2: 10.3388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.0e0f5344b2b93c3f258569c696f8584c.svg";
export { ForwardRef as ReactComponent };